

















import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
class IconMine extends Vue {
  @State(state => state.app.bottomNav) currentNav;

  @State(state => state.app.settings.dark) isDark;

  get colors() {
    const active = this.$vuetify.theme.currentTheme.primary;
    const inactive = this.$vuetify.theme.currentTheme.grayscale_4;

    return this.currentNav === "mine" ? [active] : [inactive];
  }
}
export default IconMine;
